import type { ID, Maybe, ModelType } from '@/types'
import type { MakeMaybe } from '@/types/utilities'
/**
 * Blocks
 * */
export interface Block<T = BlockParameters> extends MakeMaybe<ModelType, 'id'> {
  name: Maybe<string>
  parameters: T
  type: BlockTypes
  type_human?: string
}
export type PostBlock = Block<PostParameters>
export type BannerBlock = Block<BannerParameters>
export type ProductsBlock = Block<ProductsParameters>
export type PresetsBlock = Block<PresetsParameters>

export type ProductsBlockForm = Omit<ProductsBlock, 'id' | 'sort'>
export type PresetsBlockForm = Omit<PresetsBlock, 'id' | 'sort'>

export enum BlockTypes {
  Banner1 = 'banner_1',
  Banner2 = 'banner_2',
  Banner3 = 'banner_3',
  Banner4 = 'banner_4',
  Posts = 'posts',
  Collections = 'collections',
  ProductsFeed = 'products_feed',
  CatalogsFeed = 'catalogs_feed',
}
/**
 * Blocks parameters
 * */
export interface BannerParameters extends BlockParameters {
  banners: Banner[]
}
export interface PostParameters extends BlockParameters {
  action: boolean
  action_text: 'Читать'
  autohide?: boolean
  posts: ID[]
}
interface BlockParameters {
  title: Maybe<string>
}
export interface ProductsParameters extends BlockParameters {
  action: boolean
  action_text: Maybe<string>
  action_link: Maybe<string>

  autohide: boolean
  autohide_discounts: boolean

  product_ids: ID[]
}
export interface PresetsParameters extends BlockParameters {
  autohide: boolean
  catalog_code: Maybe<string>
  presets_ids: ID[]
}
/**
 * Blocks content
 * */
export interface Banner {
  action: Maybe<string>
  image: Maybe<string>
  link: Maybe<string>
  subtitle: Maybe<string>
  title: Maybe<string>
  color_text: Maybe<string>
}
